import {
  FETCH_ATTENDEE,
  OPEN_ATTENDEE_PROFILE,
  SHOW_BACK_SCREEN,
  MY_BOOKMARKED_USERS,
  FILTER_LIST_OPEN,
  MATCH_ATTENDEE_CATEGORY,
  MAIN_ATTENDEE_LIST
} from '../actions';

export const attendeeList = (state = {}, action) => {
  if (action.type === FETCH_ATTENDEE) return action.payload;
  return state;
};

export const userData = (state = {}, action) => {
  if (action.type === FETCH_USERS) return action.payload;
  return state;
};

export const attendeeProfileDetailsReducer = (state = {}, action) => {
  if (action.type === OPEN_ATTENDEE_PROFILE) return action.payload;
  return state;
};

export const showBackScreen = (state = false, action) => {
  if (action.type === SHOW_BACK_SCREEN) return action.payload;
  return state;
};

export const myBookmarkedUsers = (state = {}, action) => {
  if (action.type === MY_BOOKMARKED_USERS) return action.payload;
  return state;
};

export const openFilterListReducer = (state = {}, action) => {
  if (action.type == FILTER_LIST_OPEN) return action.payload;
  return state;
};

export const matchAttendeeCategoryReducer = (state = { count: 0 }, action) => {
  if (action.type == MATCH_ATTENDEE_CATEGORY) return action.payload;
  return state;
};

export const mainAttendeeList = (state = [], action) => {
  if (action.type === MAIN_ATTENDEE_LIST) return action.payload;
  return state;
};
